// extracted by mini-css-extract-plugin
module.exports = {"header":"WalletSetup_header__jm2v4","title":"WalletSetup_title__gCgPD","box":"WalletSetup_box__1TUym"};